function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 385h85v85h-85zm170 0h85v85h-85zm-85 85h85v85h-85zm-85 85h85v85h-85zm170 0h85v85h-85z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255 385h85v85h-85zm0 170h85v85h-85zm425-170h85v85h-85zm0 170h85v85h-85z",
    style: {
      fill: "#ffffff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkxIcon);
export default __webpack_public_path__ + "static/media/okx-icon.8ccc64e607a36a7ca88ef5e9b27d9435.svg";
export { ForwardRef as ReactComponent };